// extracted by mini-css-extract-plugin
module.exports = {"requestorDiv":"AclUserRoleEditor_requestorDiv__2FPUZ"};